/**
 * Remote Config Reload Component
 * Reusable component for fetching and activating Remote Config
 */

import { Component } from '@angular/core';
import { IonButton, IonSpinner } from '@ionic/angular/standalone';
import { ConfigService } from '../../services/config.service';

@Component({
  selector: 'crowdctrl-remote-config-reload',
  standalone: true,
  imports: [IonButton, IonSpinner],
  templateUrl: './remote-config-reload.component.html',
  styleUrl: './remote-config-reload.component.css',
})
export class RemoteConfigReloadComponent {
  isFetchingRemoteConfig = false;

  constructor(private configService: ConfigService) {}

  async fetchRemoteConfig(): Promise<void> {
    this.isFetchingRemoteConfig = true;
    try {
      await this.configService.fetchAndActivateRemoteConfig();
    } catch (error) {
      console.error('Failed to fetch Remote Config:', error);
    } finally {
      this.isFetchingRemoteConfig = false;
    }
  }
}
